import { render, staticRenderFns } from "./bmInfo.vue?vue&type=template&id=95f4b63c&scoped=true"
import script from "./bmInfo.vue?vue&type=script&lang=js"
export * from "./bmInfo.vue?vue&type=script&lang=js"
import style0 from "./bmInfo.vue?vue&type=style&index=0&id=95f4b63c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f4b63c",
  null
  
)

export default component.exports